import type { PpsfBand } from '@/components/search/ppsf-band'
import { formatCount } from '@/lib/format/count'
import { livingAreaListingCount } from '@/lib/listing-counts'

/**
 * Visible comparison sentence for a search card.
 * Numbers are the same band the pins and the rail already share (SITE-44).
 *
 * UX review F13 (2026-10-15): "$422/sqft · middle half of 436 on this map"
 * repeated the facts line's $/sqft and read as jargon. Say it plainly; the
 * exact band stays in the hover / screen-reader label (ppsf-band bandLabel).
 *
 * W1 (audit v2 2.1): the band counts only the homes that report a living
 * area, so "of 431 homes on this map" under a claim of 489 read as a second
 * count of one map. The figure now names its basis (livingAreaListingCount).
 * TODO(Writing Bot): the basis rides the card's one-line readout at full
 * length; tighten the wording if it wraps on a phone card.
 */
export function bandReadout(band: PpsfBand, value: number | null): string {
  const counted = livingAreaListingCount(band.n)
  const set = `${formatCount(counted.count)} homes on this map ${counted.basis.label}`
  if (value == null || !(value > 0)) return 'No living area reported'
  if (value < band.q1) return `Lower $/sqft than most of ${set}`
  if (value > band.q3) return `Higher $/sqft than most of ${set}`
  return `Typical $/sqft for ${set}`
}
